import { Component, inject } from '@angular/core';
import { LocalizedUrlService } from '../../core/services/localized-url.service';

@Component({
  selector: 'app-about-page',
  template: `
    <app-page-section
      class="-mt-16 lg:-mt-20 xl:-mt-[100px]"
      backgroundColor="secondary"
      [waves]="true"
      [noContainer]="true"
    >
      <div class="container max-w-3xl text-center">
        <div class="flex items-center justify-center gap-3 text-white/40">
          <span class="text-2xl font-light">/</span>
          <i class="fal fa-users text-white text-2xl"></i>
          <span class="text-2xl font-light">/</span>
        </div>
        <div class="text-center text-white">
          <h1 class="mt-6">{{ 'about.hero.title' | transloco }}</h1>
          <p class="mt-8 text-lg text-balance">{{
            'about.hero.description' | transloco
          }}</p>
        </div>
      </div>

      <div class="container">
        <div class="mt-8 flex flex-wrap justify-center gap-6">
          <a [routerLink]="localizedUrl.link('search')">
            <app-button>{{ 'about.hero.cta-directory' | transloco }}</app-button>
          </a>
        </div>
      </div>
    </app-page-section>

    <div class="pt-16 xl:pt-0"></div>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true" scrollTriggerStart="top 100%">
        <img
          src="/assets/img/garder-le-controle.svg"
          [alt]="'about.control.img-alt' | transloco"
          [title]="'about.control.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{ 'about.control.tag' | transloco }}</app-public-tag>
          <h2>{{ 'about.control.title' | transloco }}</h2>
          <p [innerHTML]="'about.control.p1' | transloco"></p>
          <p>{{ 'about.control.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section>
      <app-feature-section>
        <img
          src="/assets/img/location-heure-journee.svg"
          [alt]="'about.flexibility.img-alt' | transloco"
          [title]="'about.flexibility.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{
            'about.flexibility.tag' | transloco
          }}</app-public-tag>
          <h2 [innerHTML]="'about.flexibility.title' | transloco"></h2>
          <p>{{ 'about.flexibility.p1' | transloco }}</p>
          <p>{{ 'about.flexibility.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true">
        <img
          src="/assets/img/gestion-des-salles.svg"
          [alt]="'about.management.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{
            'about.management.tag' | transloco
          }}</app-public-tag>
          <h2>{{ 'about.management.title' | transloco }}</h2>
          <p>{{ 'about.management.p1' | transloco }}</p>
          <p>{{ 'about.management.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section>
        <img
          src="/assets/img/louer-groupe-de-salles.svg"
          [alt]="'about.room-groups.img-alt' | transloco"
          [title]="'about.room-groups.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{
            'about.room-groups.tag' | transloco
          }}</app-public-tag>
          <h2>{{ 'about.room-groups.title' | transloco }}</h2>
          <p>{{ 'about.room-groups.p1' | transloco }}</p>
          <p>{{ 'about.room-groups.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section [imageFirst]="true">
        <img
          src="/assets/img/solution-collaborative.svg"
          [alt]="'about.collaboration.img-alt' | transloco"
          [title]="'about.collaboration.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{
            'about.collaboration.tag' | transloco
          }}</app-public-tag>
          <h2>{{ 'about.collaboration.title' | transloco }}</h2>
          <p>{{ 'about.collaboration.p1' | transloco }}</p>
          <p>{{ 'about.collaboration.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section padding="sm">
      <app-feature-section>
        <img
          src="/assets/img/outil-accessible.svg"
          [alt]="'about.accessibility.img-alt' | transloco"
          [title]="'about.accessibility.img-alt' | transloco"
          image
        />
        <div class="flex flex-col gap-6" body>
          <app-public-tag>{{
            'about.accessibility.tag' | transloco
          }}</app-public-tag>
          <h2>{{ 'about.accessibility.title' | transloco }}</h2>
          <p>{{ 'about.accessibility.p1' | transloco }}</p>
          <p>{{ 'about.accessibility.p2' | transloco }}</p>
        </div>
      </app-feature-section>
    </app-page-section>

    <app-page-section>
      <div class="flex justify-center">
        <app-button
          [routerLink]="localizedUrl.link('pricing')"
          icon="arrow-right"
          >{{ 'about.cta-offers' | transloco }}</app-button
        >
      </div>
    </app-page-section>

    <app-page-section
      padding="lg"
      [noContainer]="true"
      [waves]="true"
      backgroundColor="secondary"
      offsetImage="cactus.png"
    >
      <div class="container text-right">
        <div class="mx-auto max-w-[800px]">
          <blockquote class="text-3xl font-medium text-white">
            {{ 'about.quote.text' | transloco }}
          </blockquote>
          <div class="mt-6">
            <div class="flex flex-col items-end gap-1 sm:hidden">
              <p class="text-sm font-medium text-white">{{
                'about.quote.role' | transloco
              }}</p>
              <app-public-tag>{{ 'about.quote.org' | transloco }}</app-public-tag>
            </div>
            <div class="hidden sm:flex sm:justify-end sm:gap-2">
              <app-public-tag>{{
                'about.quote.role' | transloco
              }}</app-public-tag>
              <app-public-tag>{{ 'about.quote.org' | transloco }}</app-public-tag>
            </div>
          </div></div
        >
      </div>
    </app-page-section>

    <div class="h-20 bg-white"></div>
  `,
  standalone: false,
})
export class AboutPageComponent {
  protected localizedUrl = inject(LocalizedUrlService);
}
